import { Outlet } from 'react-router-dom';

// ................................................

export default function LoginCallbackLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
